import { ChainlitContext, useConfig } from "@chainlit/react-client";
import { useContext } from "react";

interface CustomLogoProps {
  className?: string;
}

const CustomLogo = ({ className = "w-20 h-auto py-4" }: CustomLogoProps) => {
  const apiClient = useContext(ChainlitContext);
  return (
    <img
      src={apiClient.getCopilotAssetsEndpoint("mci_logo.svg")}
      alt="Logo"
      className={className}
    />
  );
};

export default CustomLogo;
